<template>
  <div>
    <CheckboxGroup
      v-model="inValue"
      @on-change="onCheckBoxGroupChange"
    >
      <p
        class="iv-select-tree-check-list iv-fs-14 iv-fc-85 iv-m-b-8"
        v-for="(item, inx) in list"
        :key="item.value + '' + inx"
      >
        <Checkbox :label="item.value || item.title">{{ selectUserSwitch ? item.fullTitle : item.title}}</Checkbox>
      </p>
    </CheckboxGroup>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    list: {
      type: Array,
      default () {
        return []
      }
    },
    allList: {
      type: Array,
      default () {
        return []
      }
    },
    selectUserSwitch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inValue: this.value
    }
  },
  watch: {
    value (newVal) {
      this.inValue = newVal
    }
  },
  methods: {
    //复选框多选
    onCheckBoxGroupChange (data) {
      let copyList = Object.assign([], this.allList)
      let arr = []
      data.forEach(val => {
        copyList.map(item => {
          if (val === item.value) {
            let isHas = arr.find(arrItem => arrItem.value === item.value)
            if (!isHas) {
              arr.push(item)
            }
          }
        })
      })
      this.$emit('on-check-change', arr)
    }
  }
}
</script>
